import * as React from 'react'

interface useCheckedListReturnInterface {
  checkedItems: number[]
  isCheckedAllItems: boolean
  onItemCheck: (type: boolean, id: number) => void
  onAllCheck: () => void
}

export const useCheckedList = (
  items: number[]
): useCheckedListReturnInterface => {
  const [checkedItems, setCheckedItems] = React.useState<number[]>([])
  const [isCheckedAllItems, setIsCheckedAllItems] = React.useState(false)

  React.useEffect(() => {
    const handleIsCheckedAllLeadsChange = (): void => {
      if (isCheckedAllItems) {
        return setCheckedItems([])
      }
    }

    handleIsCheckedAllLeadsChange()
  }, [isCheckedAllItems])

  const onItemCheck = (type: boolean, id: number): void => {
    if (type) {
      return setCheckedItems((prevCheckedLeads) => [...prevCheckedLeads, id])
    }

    if (isCheckedAllItems && items) {
      setIsCheckedAllItems(false)

      setCheckedItems(items.filter((i) => i !== id))

      return
    }

    setCheckedItems((prevCheckedLeads) =>
      prevCheckedLeads.filter((item) => item !== id)
    )
  }

  const onAllCheck = (): void => setIsCheckedAllItems((prevState) => !prevState)

  return {
    checkedItems,
    isCheckedAllItems,
    onItemCheck,
    onAllCheck
  }
}
